import ExportIcon from './ExportIcon'

export default ExportIcon
